import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "m-0 shrink-0 flex items-center justify-between"
};
const _hoisted_2 = {
  class: "flex items-center gap-2"
};
const _hoisted_3 = {
  class: "hide-scroll-bar h-full box-border overflow-y-auto"
};
const _hoisted_4 = {
  class: "w-full min-h-full relative flex-grow bg-white box-border p-3 sm:p-7"
};
const _hoisted_5 = {
  ref: "mindMapContainer",
  class: "mindmap-container h-[100vh]"
};
import { Markmap } from 'markmap-view';
import { Transformer } from 'markmap-lib';
import { Toolbar } from 'markmap-toolbar';
import { useClipboard } from '@vueuse/core';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Preview',
  props: {
    content: {
      // 生成的结果
      type: String,
      default: ''
    }
  },
  emits: ['handle-close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const message = useMessage(); // 消息弹窗
    const {
      copied,
      copy
    } = useClipboard(); // 粘贴板
    const emits = __emit;
    /** 通过计算属性，双向绑定，更改生成的内容，考虑到用户想要更改生成文章的情况 */
    const content = computed(() => props.content);
    // 定义模板引用
    const svgRef = ref();
    const toolBarRef = ref();
    // 思维导图实例和转换器
    let markMap = null;
    const transformer = new Transformer();
    const back = () => {
      emits('handle-close');
    };
    /** 点击复制的时候复制内容 */
    const showCopy = computed(() => content.value); // 是否展示复制按钮，在生成内容完成的时候展示
    const showImage = ref(true);
    const copyContent = () => {
      copy(content.value);
    };
    // 渲染思维导图的方法
    const renderMindMap = content => {
      try {
        // 转换 Markdown 为思维导图数据
        const {
          root
        } = transformer.transform(processContent(content));
        // 设置数据并适配视图
        markMap?.setData(root);
        markMap?.fit();
      } catch (e) {
        console.error('渲染思维导图失败:', e);
      }
    };
    const handleShowImage = show => {
      if (show) {
        // 使用 nextTick 确保 DOM 更新完成后再渲染
        nextTick(() => {
          renderMindMap(content.value);
        });
      }
    };
    /** 复制成功的时候 copied.value 为 true */
    watch(copied, val => {
      if (val) {
        message.success('复制成功');
      }
    });
    onMounted(() => {
      // 初始化思维导图
      if (svgRef.value) {
        markMap = Markmap.create(svgRef.value, {
          autoFit: true,
          // 自动适配内容
          fitRatio: 0.8,
          // 适配比例
          paddingX: 20 // 水平内边距
        });
        // 创建工具栏
        if (markMap && toolBarRef.value) {
          const {
            el
          } = Toolbar.create(markMap);
          toolBarRef.value.append(el);
        }
        // 渲染思维导图
        renderMindMap(content.value);
      }
    });
    /** 处理内容 */
    const processContent = text => {
      const arr = [];
      const lines = text.split('\n');
      for (let line of lines) {
        if (line.indexOf('```') !== -1) {
          continue;
        }
        line = line.replace(/([*_~`>])|(\d+\.)\s/g, '');
        arr.push(line);
      }
      return arr.join('\n');
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        class: "my-card h-full"
      }, {
        header: _withCtx(() => [_createElementVNode("h3", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: back,
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "mynaui:fat-arrow-left"
          })]),
          _: 1
        }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "预览", -1)), _createVNode(_component_el_switch, {
          modelValue: showImage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showImage.value = $event),
          "inline-prompt": "",
          "active-text": "思维导图",
          "inactive-text": "原始代码",
          onChange: handleShowImage
        }, null, 8, ["modelValue"])]), _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: copyContent,
          size: "small"
        }, {
          icon: _withCtx(() => [_createVNode(Icon, {
            icon: "ph:copy-bold"
          })]),
          default: _withCtx(() => [_cache[3] || (_cache[3] = _createTextVNode(" 复制 "))]),
          _: 1
        }, 512), [[_vShow, showCopy.value]])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock("svg", {
          ref_key: "svgRef",
          ref: svgRef,
          class: "w-full h-[calc(100vh-100px)]"
        }, null, 512)), _createElementVNode("div", {
          ref_key: "toolBarRef",
          ref: toolBarRef,
          class: "absolute bottom-[20px] right-5"
        }, null, 512)], 512), [[_vShow, showImage.value]]), _withDirectives(_createVNode(_component_el_input, {
          id: "inputId",
          type: "textarea",
          modelValue: content.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => content.value = $event),
          autosize: "",
          "input-style": {
            boxShadow: 'none'
          },
          resize: "none",
          placeholder: "生成的内容……"
        }, null, 8, ["modelValue"]), [[_vShow, !showImage.value]])])])]),
        _: 1
      });
    };
  }
});